import gql from 'graphql-tag';

import COULD_NOT_COMPLETE_FRAGMENT from '../serviceDocket/COULD_NOT_COMPLETE_FRAGMENT';
import DAILY_BRIEF_FRAGMENT from './DAILY_BRIEF_FRAGMENT';

const DAILY_DEBRIEF_FRAGMENT = gql`
	fragment serviceRunDailyDebrief on ServiceRun {
		...serviceRunDailyBrief
		serviceDockets {
			id
			serviceNote
			...stopCouldNotComplete
			pickList {
				id
				pickers {
					id
					firstname
					lastname
					username
					destroyed
				}
			}
		}
		debriefComment
		myDayConfirmations {
			key
			at
		}
		myDayOrderChanges {
			at
			reason
			serviceDocket {
				id
			}
		}
		checklistSubmissions {
			id
			purpose
			status
			submittedAt
			flaggedItemIds
			approvedAt
			signOffManager {
				id
				firstname
				lastname
			}
			signOffNote
			approvedBy {
				id
				firstname
				lastname
			}
			answers
			template {
				id
				title
				requiresManagerApproval
				items
			}
		}
		driverClockSummary {
			clockedInAt
			clockedOutAt
			workedMinutes
		}
	}
	${DAILY_BRIEF_FRAGMENT}
	${COULD_NOT_COMPLETE_FRAGMENT}
`;

export default DAILY_DEBRIEF_FRAGMENT;
